<template>
    <div class="spot-rows">
        <h6>Most Loved</h6>
        <div class="results">
            <ul class="spot-row-list">
                <li v-for="spot in spots" :key="`most-loved-${spot.id}`" class="spot-row-item">
                    <a class="item-content" :href="`/${spot.city.slug}/${spot.slug}?source-list=${list.slug}`">
                        <img :src="spot.sm_featured_image" :alt="spot.title">
                        <div class="info">
                            <h4 v-text="spot.title"></h4>
                            <div class="details">
                                <span v-text="spot.category.title"></span> in <span v-text="spot.city.title"></span>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: ['list'],

    data() {
        return {
            spots: []
        }
    },

    created() {
        this.fetchSpots()
    },

    methods: {
        fetchSpots() {

            let destinationIds = _.map(this.list.destinations, d => d.id)

            axios.get(`/most-loved-spots`, {
                params: {
                    destination_ids: destinationIds,
                    take: 4,
                }
            })
                .then(response => {
                    this.spots = response.data.most_loved_spots
                })
                .catch(errors => {
                    console.log(errors)
                })
        }
    }
}
</script>
